export default __webpack_public_path__ + "static/media/586.9f988662.jpg";